import {
  Text,
  VStack,
  Wrap,
  Button,
  Box,
  useBreakpointValue,
} from '@chakra-ui/react'
import Image from 'next/image'
import { useTranslation } from 'next-i18next'

import { useProducts } from '@/features/otherServices/constants'
import ImageHeader from '@/images/other-services/header.jpg'

import ScrollLink from '@/lib/scroll'
import { logEvent } from '@/lib/gtm'

function PageHeader(): React.ReactElement {
  const products = useProducts()

  const { t } = useTranslation('otherServices')

  const buttonSize = useBreakpointValue({
    base: 'lg',
    xs: 'lg',
    sm: 'xl',
    md: 'xl',
  })

  return (
    <VStack
      spacing="16"
      sx={{
        py: 20,
        w: '100%',
        position: 'relative',
      }}
    >
      <Box sx={{ position: 'absolute', top: 0, left: 0, w: 'full', h: 'full' }}>
        <Image
          priority
          src={ImageHeader}
          layout="fill"
          objectFit="cover"
          placeholder="blur"
        />
      </Box>
      <VStack
        spacing="5"
        layerStyle="container"
        sx={{
          color: 'white',
          position: 'relative',
          pt: 0,
          pb: 0,
          textAlign: 'center',
        }}
      >
        <Text
          as="h1"
          sx={{
            fontWeight: 'bold',
            fontSize: { base: '3.5xl', sm: '4xl', md: '5.5xl' },
          }}
        >
          {t('header.title')}
        </Text>
        <Text
          as="h2"
          sx={{
            fontSize: { base: 'xl', sm: '2xl', md: '3xl' },
          }}
        >
          {t('header.subtitle')}
        </Text>
      </VStack>
      <VStack
        spacing="10"
        sx={{
          position: 'relative',
          maxW: '100vw',
          px: 10,
        }}
      >
        <Wrap spacing="7" justify="center">
          {products.map((product, index) => {
            return (
              <ScrollLink
                key={`${index}-${product.id}`}
                url={{ pathname: 'currentPath', hash: product.id }}
              >
                <Button
                  variant="outline"
                  size={buttonSize}
                  onClick={() => {
                    logEvent({
                      ga: {
                        category: 'Other Services',
                        action: `Click ${product.title}`,
                      },
                    })
                  }}
                  sx={{
                    w: '200px',
                    border: '2px solid',
                    color: 'white',
                    borderColor: 'currentColor',
                    borderRadius: '999px',
                    fontWeight: 'medium',
                    transition: 'background-color 200ms',
                    '&:hover': {
                      bg: 'primary.400',
                    },
                    minW: 'unset',
                  }}
                >
                  {product.title}
                </Button>
              </ScrollLink>
            )
          })}
        </Wrap>
      </VStack>
    </VStack>
  )
}

export default PageHeader
